import { getDigitsFromPriceAndAmount } from '@morpho-org/ui-v6/utils'
import { parseEther } from 'viem'

/** Digits of an asset amount, from the asset's spot USD price as `parseApiAsset` scales it. */
export function getAssetAmountDigits(
  priceUsd: number | null | undefined,
  amount: bigint | null,
  decimals: number | null | undefined
): number {
  const price = priceUsd == null ? undefined : parseEther(priceUsd.toFixed(18))
  return getDigitsFromPriceAndAmount(price, amount, decimals ?? undefined)
}
